import PressKitView from '@/views/PressKit/PressKit';
import { GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';

export default function PressKit() {
  return (
    <>
      <NextSeo title={undefined} />
      <PressKitView />
    </>
  );
}

export const getServerSideProps = ({ locale }: GetServerSidePropsContext) => ({
  props: { locale },
});
